export default __webpack_public_path__ + "static/media/arrow.065e3315.svg";